// This file is auto-generated by scripts/update-version.js
// Do not edit this file manually
// Generated on: 2026-09-16T06:36:36.276Z

export const VERSION = '2.0.20250904';
export const BUILD_DATE = '20260916.0636';
